import React from 'react';

import Header from './Header';
import PrimaryButton from './Button/PrimaryButton';
import DownloadButton from 'containers/WisbitPage/HeaderButtons/DownloadButton';

type ListHeaderProps = {
  header: string;
  subtitle?: string;
  onDownload?: () => void;
  onAdd?: () => void;
};

function ListHeader({header, onDownload, onAdd, subtitle}: ListHeaderProps) {
  return (
    <div className="flex justify-between items-center w-full">
      <div className="flex flex-col">
        <Header title={header} subtitle={subtitle} className="pb-8" />
      </div>
      <div className="flex items-center">
        {onDownload && <DownloadButton onClick={onDownload} />}
        {onAdd && (
          <PrimaryButton
            disabled={!onAdd}
            className="px-4 py-3 ml-5"
            onClick={onAdd}
          >
            Nieuw +
          </PrimaryButton>
        )}
      </div>
    </div>
  );
}

export default ListHeader;
